import { useMutation } from "@apollo/client/react";
import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_SITUACION_ACTUAL_VISITA_CD, { adaptSituacionActualCDInput } from "../../../../../../data/graphQL/mutations/Visitas/saveSituacionActualCD";
import { SAVE_SITUACION_ACTUAL, SAVE_VISITA_CP_SOCIO_FAMILIAR, adaptVisitaCPSituacionActualInput, adaptVisitaCPSocioFamiliarInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaCP";
import CardBox from "../../CardBox/CardBox";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

// Config pura, fuera del componente: mapea cada variante a lo que la diferencia
// (mutation, adapter, stepId/stepName e inputs propios).
const STEP_CONFIG = {
    SituacionActual: {
        mutation: SAVE_SITUACION_ACTUAL_VISITA_CD,
        adapter: adaptSituacionActualCDInput,
        stepId: "situacionActual",
        stepName: "Situación Actual",
        inputs: [
            {
                name: "obsSituacionActual",
                displayName: "Observación",
                type: "extended_string",
                required: true
            }]

    },
    SituacionActualCP: {
        mutation: SAVE_SITUACION_ACTUAL,
        adapter: adaptVisitaCPSituacionActualInput,
        stepId: "situacionActual",
        stepName: "Situación Actual",
        inputs: [
            {
                name: "observacionSituacionActual",
                displayName: "Observación",
                type: "extended_string",
                required: true
            }]

    },
    SituacionSocioFamiliar: {
        mutation: SAVE_VISITA_CP_SOCIO_FAMILIAR,
        adapter: adaptVisitaCPSocioFamiliarInput,
        stepId: "situacionSocioFamiliar",
        stepName: "Situación Socio Familiar",
        inputs: [
            {
                name: "cuidadorPrincipal",
                displayName: "Cuidador Principal",
                type: "long_string",
                required: true
            },
            {
                name: "espacioCuidado",
                displayName: "Espacio de Cuidado",
                type: "long_string",
                required: false
            },
            {
                name: "comunicacionDecisiones",
                displayName: "Comunicación y toma de decisiones",
                type: "long_string",
                required: false
            }]

    }
};

export const SituacionVisitaStep = ({ variant, readOnly, onSaveRef, onExposeFormatted }) => {
    const config = STEP_CONFIG[variant];

    const [formData, setFormData] = useState({});
    const { visita, setVisita } = useVisita();

    const [save] = useMutation(config.mutation);

    const formattedInputs = useMemo(() => {
        return config.inputs.map((input) => {
            const newInput = { ...input };

            if (readOnly) newInput.disabled = true;

            return newInput;
        });

    }, [config.inputs, readOnly, formData]);

    const handleChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    useStepSave(onSaveRef, async (validate) => {
        if (validate) validateStepFields({ formattedInputs, formData });

        const { data } = await save({ variables: { input: config.adapter(formData) } });

        setVisita((prev) => ({
            ...prev,
            ...formData
        }));
    });

    useEffect(() => {
        setFormData(visita);
    }, [visita]);

    useEffect(() => {
        onExposeFormatted?.({
            stepId: config.stepId,
            stepName: config.stepName,
            formattedInputs
        });
    }, [onExposeFormatted, formattedInputs, config.stepId, config.stepName]);

    return (
        <CardBox>
            <Grid container spacing={2}>
                {formattedInputs.map((input) =>
                    <Grid size={{ xs: 12 }} key={input.name}>
                        <RenderInputByTypeMobile
                            key={input.name}
                            input={input}
                            value={formData[input.name]}
                            handleChange={handleChange} />

                    </Grid>
                )}
            </Grid>
        </CardBox>);

};